import type { StateCreator } from 'zustand';
import type Grant from '../../interfaces/Grant';

export interface GrantsSlice {
  grants: Grant[];
  setGrants: (grants: Grant[]) => void;
  removeGrant: (grantId: number) => void;
  updateGrants: (updater: (prev: Grant[]) => Grant[]) => void;
  pendingGrants: Grant[];
  setPendingGrants: (grants: Grant[]) => void;
  removePendingGrant: (grantId: number) => void;
  updatePendingGrants: (updater: (prev: Grant[]) => Grant[]) => void;
}

type WithMW = [];

export const createGrantsSlice: StateCreator<GrantsSlice, WithMW, [], GrantsSlice> = (set) => ({
  grants: [],
  setGrants: (grants) => set({ grants }),
  removeGrant: (grantId) =>
    set((state) => ({
      grants: state.grants.filter((g) => g.id !== grantId),
    })),
  updateGrants: (updater) =>
    set((state) => ({
      grants: updater(state.grants),
    })),
  pendingGrants: [],
  setPendingGrants: (grants) => set({ pendingGrants: grants }),
  removePendingGrant: (grantId) =>
    set((state) => ({
      pendingGrants: state.pendingGrants.filter((g) => g.id !== grantId),
    })),
  updatePendingGrants: (updater) =>
    set((state) => ({
      pendingGrants: updater(state.pendingGrants),
    })),
});
